// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageSection_root__FcZxO","imageWrapper":"ImageSection_imageWrapper__lDNGV","image1":"ImageSection_image1__f9gow","image2":"ImageSection_image2__XvZrj"};